import React, { MouseEventHandler } from 'react';
import { Box, Card, Flex, Text, ThemeIcon, Title, Anchor } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import { ModuleData } from '../../constants/navigation';

type Props = {
    showShadow?: boolean;
    selected?: boolean;
} & ModuleData;

function ModuleSelectionItem({
    value,
    description,
    Icon,
    color,
    link,
    showShadow = true,
    selected = false,
}: Props) {
    const navigate = useNavigate();

    const handleNavigate: MouseEventHandler<HTMLAnchorElement> = e => {
        e.preventDefault();
        localStorage.setItem('selectedModule', value);
        navigate(link);
    };

    return (
        <Anchor
            px={showShadow ? '10px' : '0px'}
            py={showShadow ? '6px' : '0px'}
            onClick={handleNavigate}
            key={value}
            href={link}
            underline="never"
            className={showShadow ? 'block w-full' : undefined}
        >
            <Card
                className={`${showShadow ? 'w-full ' : ''}hover:bg-[${
                    selected ? '#E9ECEF' : '#F8F9FA'
                }] rounded-md ${
                    selected
                        ? 'bg-[#E9ECEF] cursor-default'
                        : 'cursor-pointer hover:bg-blue-100'
                }`}
                shadow={showShadow ? 'md' : undefined}
            >
                <Flex align="center" gap="sm">
                    <ThemeIcon
                        color={color}
                        variant="light"
                        radius="xl"
                        h="39px"
                        w="39px"
                    >
                        <Icon />
                    </ThemeIcon>
                    <Box>
                        <Title order={6} className="font-semibold">
                            {value}
                        </Title>
                        <Text size="xs" className="text-gray-400 font-semibold">
                            {description}
                        </Text>
                    </Box>
                </Flex>
            </Card>
        </Anchor>
    );
}

export default ModuleSelectionItem;
